export default function normalizeUrl(url) {
  if (!url) {
    return null
  }

  return url.replace(/\/$|\/(?=\?)/, '')
}
